import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "modal", "fechaInput", "error", "badgeConfirmado", "badgeAConfirmar"]
  static values = {
    url: String,
    confirmado: Boolean,
    finalizado: Boolean
  }

  connect() {
    this.updateUI()
  }

  onToggleClick(e) {
    e.preventDefault()
    if (this.finalizadoValue) return

    if (this.confirmadoValue) {
      this.unconfirm()
    } else {
      this.openModal()
    }
  }

  openModal() {
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    document.body.style.overflow = "hidden"
    this.hideError()
    setTimeout(() => this.fechaInputTarget.focus(), 100)
  }

  closeModal() {
    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")
    document.body.style.overflow = ""
    this.hideError()
  }

  closeModalOnBackdrop(e) {
    if (e.target === this.modalTarget) this.closeModal()
  }

  hideError() {
    this.errorTarget.classList.add("hidden")
    this.errorTarget.textContent = ""
  }

  showError(msg) {
    this.errorTarget.textContent = msg
    this.errorTarget.classList.remove("hidden")
  }

  async confirm() {
    const fecha = this.fechaInputTarget.value
    if (!fecha) {
      this.showError("Debés ingresar la fecha y hora del partido.")
      return
    }

    try {
      const token = document.querySelector("meta[name='csrf-token']")?.content
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": token || "",
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ confirmado: "true", fecha_partido: fecha })
      })

      const data = await response.json()
      if (data.error) {
        this.showError(data.error)
        return
      }

      this.confirmadoValue = true
      this.closeModal()
      window.location.reload()
    } catch (e) {
      this.showError("Error al confirmar el partido.")
    }
  }

  async unconfirm() {
    try {
      const token = document.querySelector("meta[name='csrf-token']")?.content
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": token || "",
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ confirmado: "false" })
      })

      const data = await response.json()
      if (data.error) {
        console.error(data.error)
        return
      }

      this.confirmadoValue = false
      window.location.reload()
    } catch (e) {
      console.error("Error al desconfirmar:", e)
    }
  }

  updateUI() {
    const isConfirmed = this.confirmadoValue || this.finalizadoValue

    if (this.hasToggleTarget) {
      const knob = this.toggleTarget.nextElementSibling
      if (isConfirmed) {
        this.toggleTarget.classList.remove("bg-gray-700")
        this.toggleTarget.classList.add("bg-green-600")
        if (knob) knob.classList.add("translate-x-full")
      } else {
        this.toggleTarget.classList.add("bg-gray-700")
        this.toggleTarget.classList.remove("bg-green-600")
        if (knob) knob.classList.remove("translate-x-full")
      }
    }

    if (this.hasBadgeConfirmadoTarget) {
      if (isConfirmed) {
        this.badgeConfirmadoTarget.classList.remove("hidden")
      } else {
        this.badgeConfirmadoTarget.classList.add("hidden")
      }
    }

    if (this.hasBadgeAConfirmarTarget) {
      if (isConfirmed) {
        this.badgeAConfirmarTarget.classList.add("hidden")
      } else {
        this.badgeAConfirmarTarget.classList.remove("hidden")
      }
    }
  }
}
